import React from "react";
import Option from "./option";
import { useOptions } from "../../Pregrine/ProductOptions/useOptions";

const Options = (props) => {
  const {
    optionSelections,
    availableOptions,
    onSelectionChange,
    options,
    selectedValues = [],
  } = props;

  const talonProps = useOptions({
    optionSelections,
    onSelectionChange,
    options,
    selectedValues,
  });

  const { handleSelectionChange, enabledOptions } = talonProps;

  return options.map((option, index) => (
    <Option
      {...option}
      availableOptions={availableOptions?.find(
        (availableOption) =>
          availableOption.attribute_code === option.attribute_code
      )}
      enabled={enabledOptions.get(option.attribute_id)}
      key={option.attribute_id}
      onSelectionChange={handleSelectionChange}
      selectedValue={optionSelections.get(option.attribute_id)}
    />
  ));
};

export default Options;
